import { Box, Typography, Tooltip } from "@mui/material";

const categories = {
  products: {
    color: "rgba(181, 73, 221, 1)",
    icon: "/icons/store-line-icon.svg",
    dateLabel: "Est Delivery Date",
    ordersDataDateKey: "deliveryDate",
  },
  services: {
    color: "rgba(115, 103, 240, 1)",
    icon: "/icons/toolbox-repair-icon.svg",
    dateLabel: "Due Date",
    ordersDataDateKey: "dueDate",
  },
  restaurants: {
    color: "rgba(238, 107, 96, 1)",
    icon: "/icons/bowl-food-icon.svg",
    dateLabel: "Est Delivery",
    ordersDataDateKey: "deliveryDate",
  },
  coupons: {
    color: "rgba(249, 162, 56, 1)",
    icon: "/icons/coupon-icon.svg",
    dateLabel: "Expiration Date",
    ordersDataDateKey: "expiryDate",
  },
};

const orderStatusColors = {
  "in-progress": {
    color: "rgba(28, 160, 138, 1)",
    backgroundColor: "rgba(28, 160, 138, 0.16)",
  },
  pending: {
    color: "rgba(255, 151, 51, 1)",
    backgroundColor: "rgba(255, 151, 51, 0.16)",
  },
  cancelled: {
    color: "rgba(183, 72, 74, 0.6)",
    backgroundColor: "rgba(72, 72, 72, 0.1)",
  },
  completed: {
    color: "rgba(72, 72, 72, 0.6)",
    backgroundColor: "rgba(72, 72, 72, 0.1)",
  },
};

const SingleOrderCard = ({ order, onGoingOrders = true, handleViewJob }) => {
  const formatDate = (dateStr) => (dateStr ? dateStr.replace(/\//g, ".") : "-");
  return (
    <Box
      onClick={() => handleViewJob(order, order.status)}
      sx={cardWrapperStyles}
    >
      <Box sx={{ display: "flex", gap: "12px" }}>
        <Box
          sx={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            position: "relative",
            minWidth: "fit-content",
          }}
        >
          <img
            src={order.orderImage}
            alt="order-image"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />

          <Box sx={categoryBadgeStyles(order)}>
            <img
              src={categories[order.orderCategory].icon}
              alt="filter icon"
              style={{
                width: "13.33px",
                height: "13.33px",
                filter: "brightness(0) invert(1)",
              }}
            />
          </Box>
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 600,
              lineHeight: "24px",
              color: "rgba(72, 72, 72, 0.9)",
            }}
          >
            {order.name} -{" "}
            <Tooltip title={`#${order.orderId}`} arrow>
              <Typography variant="span" sx={{ fontWeight: 400, cursor: "pointer" }}>
                {order.orderCategory === "coupons" ? "Coupon ID" : "Order ID"} #
                {String(order.orderId).slice(0, 4)}
              </Typography>
            </Tooltip>
          </Typography>

          {onGoingOrders ? (
            <Typography sx={dateTextStyles}>
              {categories[order.orderCategory].dateLabel}:{" "}
              {formatDate(
                order[categories[order.orderCategory].ordersDataDateKey]
              )}
              {order.orderCategory === "restaurants" && (
                <Typography variant="span"> at {order.deliveryTime}</Typography>
              )}
            </Typography>
          ) : (
            <Typography sx={dateTextStyles}>
              {formatDate(order.paymentDate)}
            </Typography>
          )}
        </Box>
      </Box>

      <Box sx={orderStatusStyles(order)}>
        {order.status === "in-progress" ? "Active" : order.status}
      </Box>
    </Box>
  );
};

export default SingleOrderCard;

const cardWrapperStyles = {
  px: "16px",
  py: "12px",
  borderRadius: "8px",
  backgroundColor: "rgba(255, 255, 255, 1)",
  border: "1px solid rgba(225, 225, 231, 1)",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  justifyContent: "space-between",
  cursor: "pointer",
};

const categoryBadgeStyles = (order) => {
  return {
    position: "absolute",
    bottom: "0",
    right: "0",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: categories[order.orderCategory].color,
  };
};

const orderStatusStyles = (order) => {
  return {
    p: "8px",
    borderRadius: "80px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "20px",
    textTransform: "capitalize",
    background: orderStatusColors[order.status].backgroundColor,
    color: orderStatusColors[order.status].color,
  };
};

const dateTextStyles = {
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "18px",
  color: "rgba(72, 72, 72, 0.7)",
};
